import { Theme } from "@mui/material/styles";
import { alpha } from "@mui/material";

const messageCenterMessageStyle = {
  messageContainer: {
    color: "black",
  },
  messageBubble: {
    padding: "1rem",
    hyphens: "auto",
  },
  ownMessageText: {
    overflowWrap: "break-word",
    margin: "2rem 0",
  },
  ownMessageBubble: (theme: Theme) => ({
    marginLeft: "10%",
    backgroundColor: alpha(theme.palette.primaryPale, 0.75),
  }),
  otherMessageBubble: (theme: Theme) => ({
    backgroundColor: alpha(theme.palette.primaryPale, 0.25),
  }),
  customerFeedbackBox: { padding: "1rem 0.25rem" },
};
export default messageCenterMessageStyle;
